import React, { Suspense, lazy, useState } from 'react';
import ShareRoomButton from '../../../Rooms/Buttons/ShareRoom/ShareRoomButton';
import ShareRoomDialog, {
  ShareRoomDialogProps,
} from '../../../Rooms/Share/ShareRoomDialog';

const LazyShareRoomFloatingActionButton = lazy(
  () => import('../../../Rooms/Buttons/ShareRoom/ShareRoomFloatingActionButton')
);

type ShareRoomProps = Omit<ShareRoomDialogProps, 'onClose' | 'open'>;

interface Props extends ShareRoomProps {
  disabled?: boolean;
  isFloatingActionButton?: boolean;
  isMenuItem?: boolean;
}

const ShareRoom: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    disabled = false,
    isFloatingActionButton = false,
    isMenuItem = false,
    ...shareRoomDialogProps
  } = props;

  const [sharing, setSharing] = useState(false);

  const onShare = () => {
    setSharing(true);
  };

  const onCloseShare = () => {
    setSharing(false);
  };

  const renderButton = () => {
    if (isFloatingActionButton) {
      return (
        <Suspense fallback={<></>}>
          <LazyShareRoomFloatingActionButton
            disabled={disabled}
            onClick={onShare}
          />
        </Suspense>
      );
    }

    return (
      <ShareRoomButton
        disableBreakPoint={isMenuItem}
        disabled={disabled}
        fullWidth={isMenuItem}
        onClick={onShare}
      />
    );
  };

  return (
    <>
      {renderButton()}
      <ShareRoomDialog
        {...shareRoomDialogProps}
        onClose={onCloseShare}
        open={sharing}
      />
    </>
  );
};

export default ShareRoom;
